import api from './api';

const aiContentService = {
  // 同步生成内容
  generateContent: async (data) => {
    try {
      const response = await api.post('/aigc/generate', data);
      return response.data;
    } catch (error) {
      console.error('生成内容失败:', error);
      throw error;
    }
  },

  // 流式生成内容（SSE）- 返回 EventSource URL
  getStreamUrl: (params) => {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        searchParams.append(key, value);
      }
    });
    return `/api/aigc/generate/stream?${searchParams.toString()}`;
  },

  // 获取生成历史
  getHistory: async (params = {}) => {
    try {
      const response = await api.get('/aigc/history', { params });
      return response.data;
    } catch (error) {
      console.error('获取生成历史失败:', error);
      throw error;
    }
  },

  // 获取历史详情
  getHistoryDetail: async (id) => {
    try {
      const response = await api.get(`/aigc/history/${id}`);
      return response.data;
    } catch (error) {
      console.error('获取历史详情失败:', error);
      throw error;
    }
  },

  // 收藏/取消收藏
  toggleFavorite: async (id) => {
    try {
      const response = await api.put(`/aigc/history/${id}/favorite`);
      return response.data;
    } catch (error) {
      console.error('收藏操作失败:', error);
      throw error;
    }
  },

  // 删除历史
  deleteHistory: async (id) => {
    try {
      const response = await api.delete(`/aigc/history/${id}`);
      return response.data;
    } catch (error) {
      console.error('删除历史失败:', error);
      throw error;
    }
  },

  // 获取场景上下文
  getSceneContext: async (city) => {
    try {
      const response = await api.get('/aigc/scene-context', { params: { city } });
      return response.data;
    } catch (error) {
      console.error('获取场景上下文失败:', error);
      throw error;
    }
  },

  // 获取已配置的LLM供应商
  getProviders: async (tenantId) => {
    try {
      const response = await api.get('/aigc/providers', { params: { tenantId } });
      return response.data;
    } catch (error) {
      console.error('获取供应商列表失败:', error);
      throw error;
    }
  },

  // 配置LLM供应商
  configureProvider: async (data) => {
    try {
      const response = await api.post('/aigc/providers', data);
      return response.data;
    } catch (error) {
      console.error('配置供应商失败:', error);
      throw error;
    }
  },

  // 更新供应商配置
  updateProvider: async (id, data) => {
    try {
      const response = await api.put(`/aigc/providers/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('更新供应商配置失败:', error);
      throw error;
    }
  },

  // 获取租户AI配置（风格参考、默认模型）
  getTenantSettings: async (tenantId) => {
    try {
      const response = await api.get('/aigc/tenant-settings', { params: { tenantId } });
      return response.data;
    } catch (error) {
      console.error('获取租户AI配置失败:', error);
      throw error;
    }
  },

  // 更新租户AI配置（风格参考、默认模型）
  updateTenantSettings: async (data) => {
    try {
      const response = await api.put('/aigc/tenant-settings', data);
      return response.data;
    } catch (error) {
      console.error('更新租户AI配置失败:', error);
      throw error;
    }
  },

  // 删除供应商配置
  deleteProvider: async (id, tenantId) => {
    try {
      const response = await api.delete(`/aigc/providers/${id}`, { params: { tenantId } });
      return response.data;
    } catch (error) {
      console.error('删除供应商失败:', error);
      throw error;
    }
  },

  // 获取默认 Prompt 模板
  getDefaultPrompts: async () => {
    try {
      const response = await api.get('/aigc/default-prompts');
      return response.data;
    } catch (error) {
      console.error('获取默认Prompt失败:', error);
      throw error;
    }
  },
};

export default aiContentService;
